<template>
  <div class="ten-date">
    <ten-date-header
      :year="year"
      :month="month"
      :type.sync="type"
      @btn-click="clickHeader"
    />

    <ten-date-table
      :type="type"
      :first-day-of-week="firstDayOfWeek"
      :data="data"
      :on-item-click="getClickHandler()"
    />
  </div>
</template>

<script>
import TenDateHeader from '../basic/header';
import TenDateTable from '../basic/table';

import {
  getWeeks,
  getYears,
  getMonths,
  flagActive,
  subtractMonth,
  addMonth,
  getToday,
  firstUpperCase } from '../util';

export default {
  name: 'TenDatePanel',
  components: {
    TenDateHeader,
    TenDateTable,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Date,
      default: () => getToday(),
    },
    mode: {
      type: String,
      default: 'date',
      validator: v => ['year', 'month', 'date'].indexOf(v) > -1,
    },
    minDate: Date,
    maxDate: Date,
    firstDayOfWeek: Number,
    disabledDate: Function,
  },
  data() {
    return {
      year: this.value.getFullYear(),
      month: this.value.getMonth(),
      type: this.mode,
    };
  },
  computed: {
    data() {
      const { year, month, type, value, mode, disabledDate, minDate, maxDate, firstDayOfWeek } = this;
      let data;;
      const options = {
        disabledDate,
        minDate,
        maxDate,
        firstDayOfWeek,
      };

      switch (type) {
        case 'date':
          data = getWeeks({ year, month }, options);
          break;
        case 'month':
          data = getMonths(year, options);
          break;
        case 'year':
          data = getYears(year, options);
          break;
        default:
          break;
      }

      const start = (type === 'date' || type === mode) ? value : new Date(year, month);

      return flagActive(data, { start, type });
    },
  },
  watch: {
    mode(value) {
      this.type = value;
    },
    value(value) {
      this.year = value.getFullYear();
      this.month = value.getMonth();
    },
  },
  methods: {
    getClickHandler() {
      return this[`click${firstUpperCase(this.type)}`];
    },
    clickDate(date) {
      this.$emit('change', date);
    },
    clickMonth(date) {
      if (this.mode === 'month') {
        this.$emit('change', date);
      } else {
        this.type = 'date';
        this.year = date.getFullYear();
        this.month = date.getMonth();
      }
    },
    clickYear(date) {
      if (this.mode === 'year') {
        this.$emit('change', date);
      } else {
        this.type = 'month';
        this.year = date.getFullYear();
      }
    },
    clickHeader(btnType, flag) {
      let monthCount; let next;
      switch (this.type) {
        case 'date':
          monthCount = btnType === 'double' ? 12 : 1;
          break;
        case 'month':
          monthCount = btnType === 'double' ? 60 : 12;
          break;
        case 'year':
          monthCount = btnType === 'double' ? 240 : 120;
      }

      const current = new Date(this.year, this.month);

      if (flag === 1) {
        next = addMonth(current, monthCount);
      } else {
        next = subtractMonth(current, monthCount);
      }

      this.year = next.getFullYear();
      this.month = next.getMonth();
    },
  },
};
</script>
